import React, { Fragment, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Provisiones from './provisiones';
import { configuracionFormAction44, obtenerCoberturaPoliza, obtenerComboInstanciaProvisiones, obtenerComboMonedas, obtenerDatosGestionImplicado, 
    obtenerProvisionesVigentes, obtenerComboResponsabilidadAsegurado, obtenerAmparosCia, obtenerReservaCia, obtenerComboDecisionCia } from '../../../store/actions/visar-provision-action';
import { useSelector, useDispatch } from 'react-redux';
import { Auth } from 'recupero-comunes';
import GrillaPrevImplicadosHistorial from './components/grillaPrevImplicadosHistorial';


const VisaProvisionesModal = ({ action, showModal, setShowModal, implicado, origenVisar, idTrxOrigen, onTareaGestionada }) => {
    const dispatch = useDispatch();
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const visar_provision = useSelector((state) => state.visarProvisionReducer);
    const { llaves } = data_encargado;
    const { datosGestionImplicado } = visar_provision;
    const [showImplicadosHistorial, setShowImplicadosHistorial] = useState(false);
    const [tipoMovimientoGrilla, setTipoMovimientoGrilla] = useState();

    useEffect(() => {
        if (showModal && llaves) {
            let query = Buffer.from(JSON.stringify({ rutcia: llaves['idOrgCaso'], idform: 44 })).toString('base64');
            dispatch(configuracionFormAction44(query))
                .then(() => {
                    let query = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": implicado })).toString('base64')
                    dispatch(obtenerDatosGestionImplicado(query))
                })
                .then(() => {
                    let query = Buffer.from(JSON.stringify({ concepto: 263 })).toString('base64')
                    dispatch(obtenerComboInstanciaProvisiones(query))
                })
                .then(() => {
                    let query = Buffer.from(JSON.stringify({ concepto: 309 })).toString('base64')
                    dispatch(obtenerComboResponsabilidadAsegurado(query))
                })
                .then(() => {
                    let query = Buffer.from(JSON.stringify({ concepto: 311 })).toString('base64')
                    dispatch(obtenerComboDecisionCia(query))
                });
            setShowImplicadosHistorial(false);
        }
    }, [showModal, llaves])

    useEffect(() => {
        if (showModal && datosGestionImplicado) {
            let query = Buffer.from(JSON.stringify({
                idCaso: llaves && llaves['idCaso'],
                idImplicado: implicado,
                tipoGestion: datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codTipoGestion,
                tipoMovimiento: action === "provision" ? 261002 : 261003,
                situacion: "245002, 245005"
            })).toString('base64')

            dispatch(obtenerProvisionesVigentes(query))
                .then(() => {
                    const paisOrganizacion = Auth.currentUser().paisOrganizacion;
                    const codClasCaso = datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codClasCaso;
                    const query = Buffer.from(JSON.stringify({ pais: paisOrganizacion, clasBien: codClasCaso })).toString('base64');

                    dispatch(obtenerComboMonedas(query));
                })
                /*.then(() => {
                    let query = Buffer.from(JSON.stringify({
                        idCaso: llaves && llaves['idCaso'],
                        idImplicado: implicado,
                        tipoGestion: datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codTipoGestion,
                        tipoMovimiento: 261009,
                        situacion: 999
                    })).toString('base64')

                    dispatch(obtenerCoberturaPoliza(query))
                })*/
                .then(() => {
                    let query = Buffer.from(JSON.stringify({
                        idCaso: llaves && llaves['idCaso'],
                        idImplicado: implicado,
                        tipoGestion: datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codTipoGestion,
                        tipoMovimiento: 261002,
                        situacion: "245002, 245005",
                    })).toString('base64')
                    dispatch(obtenerReservaCia(query))
                }) 
                .then(() => {
                    let query = Buffer.from(JSON.stringify({
                        idCaso: llaves && llaves['idCaso'],
                        idImplicado: 0,
                        tipoGestion: datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codTipoGestion,
                        tipoMovimiento: 261002,
                        situacion: "245002, 245005",
                    })).toString('base64')
                    dispatch(obtenerAmparosCia(query))
                })
        }
    }, [showModal, datosGestionImplicado])

    const handleCloseProvisiones = () => {
        setShowModal(false);
        setShowImplicadosHistorial(false);
    }


    return (
        <Fragment>
            <Modal show={showModal} onHide={setShowModal} size='xl'>
                <Provisiones
                    handleClose={handleCloseProvisiones}
                    setShowImplicadosHistorial={setShowImplicadosHistorial}
                    implicado={implicado}
                    action={action}
                    origenVisar={origenVisar}
                    setTipoMovimientoGrilla={setTipoMovimientoGrilla}
                    idTrxOrigen={idTrxOrigen}
                    onTareaGestionada={onTareaGestionada}
                />
                {showImplicadosHistorial 
                    && <GrillaPrevImplicadosHistorial 
                        action={action} 
                        showModalVisar={showModal}
                        implicado={implicado}
                    />
                }

            </Modal>
        </Fragment>
    )
}

export default VisaProvisionesModal;
